// extracted by mini-css-extract-plugin
export var acceptButton = "_3e-5";
export var fullContent = "_3e-4";
export var link = "_3e-6";
export var linkIcon = "_3e-7";
export var sideContent = "_3e-3";
export var sideImage = "_3e-2";
export var sideImageWrapper = "_3e-1";
export var splitLayout = "_3e-0";